const forms = {
  state: {
    limitsList: null,
    limitsListCounter: null
  },
  mutations: {
    changeLimitsList(state, payload) {
      state.limitsList = payload;
    },
    changeLimitsListCounter(state, payload) {
      state.limitsListCounter = payload;
    }
  },
  actions: {
    changeLimitsList({ commit }, payload) {
      commit("changeLimitsList", payload);
    },
    changeLimitsListCounter({ commit }, payload) {
      commit("changeLimitsListCounter", payload);
    }
  },
  getters: {
    getLimitsList: state => {
      return state.limitsList;
    },
    getLimitsListCounter: state => {
      return state.limitsListCounter;
    }
  }
};
// eslint-disable-next-line
export default forms;
